module.exports = __webpack_public_path__ + "static/media/display24.e75a7818.jpg";